import classes from "./Box.module.css";
import { getCategoryInfos } from "../Map/utils";

const Box = ({ typeId, className, onClick, children, bg }) => {
  return (
    <div
      className={[classes.box, className].join(" ")}
      style={{ backgroundColor: bg ?? getCategoryInfos(typeId)?.bgColor }}
      onClick={() => onClick && onClick()}
    >
      {children}
    </div>
  );
};

export default Box;
